// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MhWL","title":"styles_title__CiALw"};